"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RISK_KAPSAM_ETIKETI = exports.RISK_METODOLOJI_ETIKETI = exports.RISK_SEVIYESI_ETIKETI = exports.riskItemImportReportSchema = exports.riskItemImportRowResultSchema = exports.riskItemImportSonucSchema = exports.RISK_ITEM_IMPORT_SONUCLARI = exports.riskBandListSchema = exports.riskAssessmentOptionsSchema = exports.riskEslesmeSchema = exports.riskAssessmentDetailSchema = exports.riskAssessmentListSchema = exports.riskOlceklerSchema = exports.riskAssessmentSummarySchema = exports.riskItemSummarySchema = exports.riskBandWriteSchema = exports.riskFreezeSchema = exports.riskAssessmentMemberWriteSchema = exports.riskMaddeDurumSuzgeciSchema = exports.RISK_MADDE_DURUM_SUZGECLERI = exports.RISK_MADDE_EKSIK_ETIKETI = exports.RISK_MADDE_EKSIKLERI = exports.RISK_TAKIP_GIRDISI_MESAJI = exports.RISK_TAKIP_GIRDISI_ALANLARI = exports.riskItemWriteSchema = exports.riskAssessmentUpdateSchema = exports.riskAssessmentCreateSchema = exports.RISK_YETKI_VARSAYILAN = exports.RISK_YETKI_ANAHTARI = exports.RISK_YENILEME_TAVANI_AY = exports.FINE_KINNEY_SIDDET = exports.FINE_KINNEY_FREKANS = exports.FINE_KINNEY_OLASILIK = exports.MATRIS_5X5_SIDDET = exports.MATRIS_5X5_OLASILIK = exports.riskAssessmentDurumSchema = exports.RISK_ASSESSMENT_DURUMLARI = exports.riskKapsamTipiSchema = exports.RISK_KAPSAM_TIPLERI = exports.RISK_YUKSEK_SEVIYELER = exports.riskSeviyesiSchema = exports.RISK_SEVIYELERI = exports.riskMetodolojisiSchema = exports.RISK_METODOLOJILERI = void 0;
exports.riskOlcekleri = riskOlcekleri;
exports.riskPuaniHesapla = riskPuaniHesapla;
exports.riskPuanIhlalleri = riskPuanIhlalleri;
exports.riskSeviyesiEsle = riskSeviyesiEsle;
exports.riskDofOneriEsigi = riskDofOneriEsigi;
exports.dofOnerisiGerekliMi = dofOnerisiGerekliMi;
exports.riskKabulEdilebilirMi = riskKabulEdilebilirMi;
exports.riskSkoruTuret = riskSkoruTuret;
exports.riskHedefPuanIhlalleri = riskHedefPuanIhlalleri;
exports.riskBantIhlalleri = riskBantIhlalleri;
exports.deriveRiskYenilemeVadesi = deriveRiskYenilemeVadesi;
exports.riskYenilemePeriyotIhlalleri = riskYenilemePeriyotIhlalleri;
exports.readMekanizmaRef = readMekanizmaRef;
exports.riskYetkiListesiIhlali = riskYetkiListesiIhlali;
exports.riskDegisiklikOzeti = riskDegisiklikOzeti;
exports.riskTakipGirdisiVarMi = riskTakipGirdisiVarMi;
exports.riskRutinEtiketi = riskRutinEtiketi;
exports.riskMaddeEksikleri = riskMaddeEksikleri;
exports.riskDondurmaEngeli = riskDondurmaEngeli;
const zod_1 = require("zod");
const shared_types_1 = require("@isg/shared-types");
const egitim_1 = require("./egitim");
const kapi_durumu_1 = require("./kapi-durumu");
/**
 * RİSK DEĞERLENDİRME — kural katmanı (F3B·S9; Kapsam §16.12, ERD §10d;
 * tutanak `docs/arsiv/risk-degerlendirme-kararlari-v1_0.md` — R1-R8).
 *
 * MODÜLÜN TEK CÜMLESİ: **taranmış doküman ÖLÜ VERİDİR, risk maddesi CANLI
 * BİR KAYITTIR.** Canlılığın kendiliğinden kurduğu üç bağ modülün ölçütüdür:
 * olay ↔ madde · ekipman ↔ madde · madde ↔ DÖF motoru.
 *
 * ⚠️ **SINIR ŞERHİ (B — ürün sahibinin AÇIK kararı):** F3B·S1'de olay
 * modülüne kurulan 5x5 **KAPALI SİSTEMDİR ve AYNEN KALIR** (tehlikeli
 * durum/davranış değerlendirmesi; **Fine-Kinney orada sunulmaz**). Buradaki
 * metodoloji seçimi **olay tarafına UZANMAZ** ve bu dosyadaki hiçbir tip
 * `incident`in `olasilik_5`/`siddet_5`/`puan_5x5` kolonlarını okumaz.
 * *Olay değerlendirmesi hızlı bir YARGI, risk değerlendirmesi METODOLOJİK
 * BİR ÇALIŞMADIR — aynı adı taşımaları onları aynı yapmaz. Bu şerh
 * silinirse ileride "5x5 iki yerde farklı davranıyor" diye HATA sanılır.*
 *
 * BURADA YAŞAYAN KURALLAR (hepsinin TEK okuyucusu var):
 *   riskPuaniHesapla       — ham skor TÜRETİLİR (metodolojiye göre)
 *   riskPuanIhlalleri      — girdi guard'ı (5x5'te frekans YOK, aralıklar)
 *   riskSeviyesiEsle       — bant tablosundan seviye (satır yoksa NULL)
 *   deriveRiskYenilemeVadesi — periyot 2/4/6 YIL, mevzuat sabiti
 *   readMekanizmaRef       — risk kaleminin kaza mekanizması işareti
 */
// ── Metodoloji (R4) ─────────────────────────────────────────────────────────
/**
 * v1 metodoloji seti: **5x5 + Fine-Kinney.** L-tipi Kapsam §5.1'de anılır ama
 * v1'e GİRMEZ (✏️ daraltma 18.08.2026). Seçim **TENANT DÜZEYİNDE ve TEKTİR**
 * — gerekçe konsolidasyon tezidir: 5x5'te 25 ile Fine-Kinney'de 400 aynı
 * tabloya giremez.
 */
exports.RISK_METODOLOJILERI = ['matrix_5x5', 'fine_kinney'];
exports.riskMetodolojisiSchema = zod_1.z.enum(exports.RISK_METODOLOJILERI);
/** §19/5'in KİLİTLİ dört kademesi — müşteriye açılmaz, i18n yalnız etiketi
 *  çevirir. Konsolidasyon YALNIZ bunu okur (§16.6). */
exports.RISK_SEVIYELERI = ['low', 'medium', 'high', 'unacceptable'];
exports.riskSeviyesiSchema = zod_1.z.enum(exports.RISK_SEVIYELERI);
/** Aksiyon UYARISININ (R5) eşiği: yüksek ve üstü. */
exports.RISK_YUKSEK_SEVIYELER = ['high', 'unacceptable'];
exports.RISK_KAPSAM_TIPLERI = ['lokasyon', 'faaliyet'];
exports.riskKapsamTipiSchema = zod_1.z.enum(exports.RISK_KAPSAM_TIPLERI);
exports.RISK_ASSESSMENT_DURUMLARI = ['aktif', 'arsivlenmis'];
exports.riskAssessmentDurumSchema = zod_1.z.enum(exports.RISK_ASSESSMENT_DURUMLARI);
/*
 * ✏️ **ETİKETLER — MADDE 220 / R9 (11.09.2026; Kapsam §16.12/16-g):** açılır
 * liste artık **değeri ve anlamını birlikte** gösterir — biçim
 * `değer — Seviye, açıklama`. Bugüne kadar hücrede yalnız tek harf (O/Ş/F)
 * vardı ve seçim yapan uzman *"3 neydi"* diye ölçek tablosuna bakmak
 * zorundaydı.
 *
 * ⚠️ **IP KURALI (Yönerge §5):** metinler **KENDİ DİLİMİZLE** yazıldı; ürün
 * sahibinin gösterdiği üçüncü taraf prosedürden hiçbir kalem metni
 * alınmadı. **DEĞERLER yöntemin kendisidir** ve değişmedi — kademe KÜMESİ
 * aynı, çift kilit aynı.
 *
 * ⚠️ **5x5'TE İKİ AYRI SET:** olasılık ile şiddet aynı 1-5 değerlerini
 * taşır ama aynı ANLAMI taşımaz (*"4 — yüksek"* bir olasılıkta sıklık, bir
 * şiddette yaralanma ağırlığı demektir). Tek listenin iki eksende paylaşılması
 * etiketi anlamsızlaştırıyordu.
 */
/** 5x5 olasılık — değerler 1-5 TAM SAYI (ürün kilitli ölçek). */
exports.MATRIS_5X5_OLASILIK = [
    { deger: 1, etiket: '1 — Çok düşük, neredeyse hiç beklenmez' },
    { deger: 2, etiket: '2 — Düşük, nadiren beklenir' },
    { deger: 3, etiket: '3 — Orta, zaman zaman olabilir' },
    { deger: 4, etiket: '4 — Yüksek, sıkça olabilir' },
    { deger: 5, etiket: '5 — Çok yüksek, neredeyse kesin' },
];
/** 5x5 şiddet — olasılıkla AYNI değerler, FARKLI anlam. */
exports.MATRIS_5X5_SIDDET = [
    { deger: 1, etiket: '1 — Çok hafif, iş günü kaybı yok' },
    { deger: 2, etiket: '2 — Hafif, ilk yardım gerektirir' },
    { deger: 3, etiket: '3 — Orta, iş günü kaybı ya da tıbbi müdahale' },
    { deger: 4, etiket: '4 — Ciddi, kalıcı hasar ya da uzuv kaybı' },
    { deger: 5, etiket: '5 — Çok ciddi, ölüm ya da tam maluliyet' },
];
exports.FINE_KINNEY_OLASILIK = [
    { deger: 0.2, etiket: '0,2 — Neredeyse imkânsız, pratikte beklenmez' },
    { deger: 0.5, etiket: '0,5 — Çok düşük, beklenmez ama akla gelir' },
    { deger: 1, etiket: '1 — Düşük, olası ama beklenmez' },
    { deger: 3, etiket: '3 — Orta, nadir ama mümkün' },
    { deger: 6, etiket: '6 — Yüksek, kuvvetle muhtemel' },
    { deger: 10, etiket: '10 — Çok yüksek, beklenir ya da kesin' },
];
exports.FINE_KINNEY_FREKANS = [
    { deger: 0.5, etiket: '0,5 — Çok seyrek, yılda bir ya da daha az' },
    { deger: 1, etiket: '1 — Seyrek, yılda birkaç kez' },
    { deger: 2, etiket: '2 — Ara sıra, ayda birkaç kez' },
    { deger: 3, etiket: '3 — Orta, haftada birkaç kez' },
    { deger: 6, etiket: '6 — Sık, günde bir ya da daha fazla' },
    { deger: 10, etiket: '10 — Sürekli, saatte birden fazla' },
];
exports.FINE_KINNEY_SIDDET = [
    { deger: 1, etiket: '1 — Önemsiz, dikkate alınmalı' },
    { deger: 3, etiket: '3 — Önemli, hafif yaralanma ya da ilk yardım' },
    { deger: 7, etiket: '7 — Ciddi, iş günü kaybı' },
    { deger: 15, etiket: '15 — Çok ciddi, uzuv kaybı ya da kalıcı hasar' },
    { deger: 40, etiket: '40 — Çok kötü, ölüm ya da tam maluliyet' },
    { deger: 100, etiket: '100 — Felaket, birden çok ölüm' },
];
/** Metodolojiye göre üç eksenin kademe listeleri — TEK KAYNAK: ekran
 *  açılır listeyi buradan çizer, sunucu doğrulamayı buradan yapar. MEVCUT
 *  ve HEDEF skor AYNI listeleri kullanır (Kapsam §16.12/16-a). */
function riskOlcekleri(metodoloji) {
    if (metodoloji === 'matrix_5x5') {
        return { olasilik: exports.MATRIS_5X5_OLASILIK, frekans: null, siddet: exports.MATRIS_5X5_SIDDET };
    }
    return {
        olasilik: exports.FINE_KINNEY_OLASILIK,
        frekans: exports.FINE_KINNEY_FREKANS,
        siddet: exports.FINE_KINNEY_SIDDET,
    };
}
function kademeIcinde(kademeler, deger) {
    // Ondalık karşılaştırma: 0.1 hassasiyetinde eşitlik (0,2 · 0,5 kademeleri).
    return kademeler.some((k) => Math.abs(k.deger - deger) < 0.001);
}
/**
 * HAM SKOR TÜRETİLİR (tek yazıcı): 5x5 = olasılık × şiddet ·
 * Fine-Kinney = olasılık × frekans × şiddet. Girdi eksikse `null` döner —
 * yarım doldurulmuş madde puansız yaşar (madde ekleme akışı bölünebilir
 * olmalı; zorunluluk GÖNDERİMDE değil, bantta görünür).
 */
function riskPuaniHesapla(metodoloji, girdi) {
    const { olasilik, frekans, siddet } = girdi;
    if (olasilik === null || siddet === null)
        return null;
    if (metodoloji === 'matrix_5x5')
        return round2(olasilik * siddet);
    if (frekans === null)
        return null;
    return round2(olasilik * frekans * siddet);
}
function round2(deger) {
    return Math.round(deger * 100) / 100;
}
/**
 * PUAN GİRDİSİ GUARD'I (422). Metodoloji **PARENT satırdan** okunur — bu
 * yüzden kural DB CHECK değil SERVİSTEDİR ("Diğer → serbest metin"
 * kuralının yerleşim sınıfı).
 *
 * En kritik satır: **5x5'te `frekans` YAZILAMAZ.** Yazılabilseydi metodoloji
 * değişince eski maddede sessizce üçüncü çarpan belirir ve puan 5 katına
 * çıkardı.
 */
function riskPuanIhlalleri(metodoloji, girdi) {
    const ihlaller = [];
    const olcek = riskOlcekleri(metodoloji);
    if (metodoloji === 'matrix_5x5' && girdi.frekans !== null) {
        ihlaller.push('5x5 metodolojisinde frekans alanı KULLANILMAZ (olasılık × şiddet)');
    }
    if (metodoloji === 'fine_kinney' && girdi.frekans !== null && olcek.frekans) {
        if (!kademeIcinde(olcek.frekans, girdi.frekans)) {
            ihlaller.push(`Frekans ölçek kademelerinden biri olmalıdır (${olcek.frekans.map((k) => k.deger).join(' · ')})`);
        }
    }
    for (const [ad, deger, kademeler] of [
        ['Olasılık', girdi.olasilik, olcek.olasilik],
        ['Şiddet', girdi.siddet, olcek.siddet],
    ]) {
        if (deger === null)
            continue;
        if (!kademeIcinde(kademeler, deger)) {
            ihlaller.push(`${ad} ölçek kademelerinden biri olmalıdır (${kademeler.map((k) => k.deger).join(' · ')})`);
        }
    }
    return ihlaller;
}
/**
 * BANT EŞLEŞTİRME — tek okuyucu. Sınırlar **DAHİLDİR** (alt ≤ skor ≤ üst).
 *
 * **Satır yoksa ya da hiçbir bant eşleşmezse `null` döner ve ÇAĞIRAN UYARI
 * ÜRETİR — kayıt ENGELLENMEZ** (madde 58/D8 "eşiksiz sınıf türetmeye
 * katılmaz" deseninin risk kolu). Fail-open değildir: seviyesiz madde
 * konsolidasyonda sayılmaz ve ekranda görünür biçimde eksiktir.
 */
function riskSeviyesiEsle(bantlar, hamSkor) {
    if (hamSkor === null)
        return null;
    for (const bant of bantlar) {
        if (hamSkor < bant.altSinir)
            continue;
        if (bant.ustSinir !== null && hamSkor > bant.ustSinir)
            continue;
        return bant.seviye;
    }
    return null;
}
/**
 * DÖF ÖNERİ EŞİĞİNİN ÇÖZÜMÜ (Y2 — Kapsam §16.12/8b).
 *
 * Eşik **yüksek bandın alt sınırıdır** — yani R5 uyarısının başladığı yer
 * (5x5'te 10 · Fine-Kinney'de 70,01). Bant tablosu tanımsızsa `null` →
 * **öneri HİÇ üretilmez.** Sistem, sınırını bilmediği puana "eşiği geçti"
 * demez (D8 / `isyeri_oran` deseni: iddia yok).
 *
 * ✏️ **REVİZE 05.09.2026 (tur 11 / R2 — ürün sahibi): ELLE EŞİK KOLU
 * KALKTI.** Fonksiyon 21.08.2026'da `ayarDegeri` de alıyordu
 * (`risk_dof_oneri_esigi` tenant anahtarı, dolu ise o kazanırdı); anahtar
 * §23 kütüğünden **düştü** ve imza tek girdiye indi.
 *
 * ⚠️ **GEREKÇE — TEK SAYILIK AYAR YÖNTEME KÖRDÜR:** anahtar açılırken
 * sistemde tek yöntem yürüyordu. R1 ile aynı holdingde 5x5 ve Fine-Kinney
 * yan yana yaşayabildiği an, *"12"* yazan bir müşteride o sayı 5x5'te makul,
 * Fine-Kinney'de **neredeyse her maddeyi** DÖF'e çağıran bir eşik olur — ve
 * kullanıcı bunu fark etmez (§2.40'ın yalan söyleyen kontrolü: ayar çalışır,
 * söylediği şey yanlıştır). Bant tablosu **zaten yöntem başına ayrıdır** ve
 * **zaten müşteride düzenlenebilir**; eşik oradan okununca ölçekle birlikte
 * taşınır — *bant tablosu TEK KAYNAK.*
 *
 * ⚠️ **Z6 AYNEN GEÇERLİ:** bu yüklem `risk_aksiyon_zorunlu` KAPISINI hâlâ
 * okumaz (öneri bir ÇAĞRI, anahtar bir KAPI).
 */
function riskDofOneriEsigi(bantlar) {
    return bantlar.find((b) => b.seviye === 'high')?.altSinir ?? null;
}
/**
 * Z2 — **GÖSTERİM YÜKLEMİ:** madde satırındaki DÖF çağrısı. HER ZAMAN GÜNCEL
 * eşikle hesaplanır, damgalanmaz (`majorArastirmaMi` / `kazaDosyasiEksikMi`
 * tek-yüklem sınıfı).
 *
 * ⚠️ **Z6 — BU YÜKLEM `risk_aksiyon_zorunlu` KAPISINI OKUMAZ ve okumamalı.**
 * İkisi aynı bandı görür ama farklı şey yapar: burası bir ÇAĞRI, orası bir
 * KAPI (`freezeRiskAssessmentVersion`). Tek fonksiyona indirgenirse anahtar
 * kapalıyken öneri de susar — müşteri sertliği kapatmıştır, yol göstermeyi
 * değil.
 */
function dofOnerisiGerekliMi(hamSkor, esik) {
    if (hamSkor === null || hamSkor === undefined || esik === null)
        return false;
    return hamSkor >= esik;
}
/** §16.6'nın ortak kolonu — TÜRETİLİR, elle girilmez. */
function riskKabulEdilebilirMi(seviye) {
    return seviye === null ? null : seviye === 'low';
}
/**
 * SKOR TÜRETMESİ — TEK YÜKLEM (madde 220 / R1 · D4; Kapsam §16.12/16-a).
 *
 * **MEVCUT ve HEDEF skor AYNI fonksiyondan geçer.** Mevcut skorun sonucu
 * yazılır (`ham_skor` · `risk_seviyesi` · `kabul_edilebilir` — §16.6'nın
 * ortak kolonu; SQL süzgeci ve R5 kapı sorgusu onu okur); hedef skorun
 * sonucu **yazılmaz**, her okumada güncel bant tablosuyla yeniden hesaplanır.
 * İki skorun iki ayrı hesap yolu olsaydı bant tablosu değiştiği gün biri
 * yeni, öteki eski sınırla etiketlenirdi.
 */
function riskSkoruTuret(metodoloji, girdi, bantlar) {
    const hamSkor = riskPuaniHesapla(metodoloji, girdi);
    const riskSeviyesi = riskSeviyesiEsle(bantlar, hamSkor);
    return { hamSkor, riskSeviyesi, kabulEdilebilir: riskKabulEdilebilirMi(riskSeviyesi) };
}
/**
 * HEDEF SKOR GUARD'I (madde 220 / R3 · R4). **Tek kısıt yöntemin kendisidir:**
 * kademe dışı değer ve 5x5'te frekans — mevcut skorla AYNI kural
 * (`riskPuanIhlalleri`), yalnız mesaj hangi skor olduğunu söyler.
 *
 * ⚠️ **R4 — BURADA HEDEF ↔ MEVCUT KARŞILAŞTIRMASI YOKTUR ve olmamalıdır.**
 * Hedefte şiddet dahil üç eksen serbesttir; *"hedef şiddet mevcuttan düşük
 * olamaz"* ya da *"hedef mevcuttan yüksek olamaz"* diye bir kural YAZILMAZ,
 * uyarı da üretilmez. Gerekçe: kaynağa müdahale (ikame · miktar azaltma ·
 * enerji düşürme) şiddeti **gerçekten** değiştirir; sınırı çizmek uzmanın
 * işidir (*sistem hesaplar ve önerir, karar sahada*). Kanaryası
 * `@isg/db risk.spec` → *"R4 — hedef şiddet serbest"*.
 *
 * ⚠️ **R3 — HEDEF ZORUNLU DEĞİL:** üç alan da boş olabilir; yarım
 * doldurulmuş hedef mevcut skor gibi PUANSIZ yaşar.
 */
function riskHedefPuanIhlalleri(metodoloji, girdi) {
    return riskPuanIhlalleri(metodoloji, girdi).map((ihlal) => `Hedef skor — ${ihlal}`);
}
/**
 * Bant tablosunun bütünlük guard'ı (422): dört kademe de bir kez, aralıklar
 * artan ve çakışmasız, yalnız EN ÜST bant açık uçlu. Çakışan bant "hangi
 * satır kazandı" sorusunu doğururdu — sıralamaya bağlı sessiz sonuç.
 */
function riskBantIhlalleri(bantlar) {
    const ihlaller = [];
    const gorulen = new Set();
    for (const bant of bantlar) {
        if (gorulen.has(bant.seviye))
            ihlaller.push(`'${bant.seviye}' bandı iki kez tanımlanmış`);
        gorulen.add(bant.seviye);
    }
    for (const seviye of exports.RISK_SEVIYELERI) {
        if (!gorulen.has(seviye))
            ihlaller.push(`'${seviye}' bandı eksik — dört kademe de tanımlanır`);
    }
    if (ihlaller.length > 0)
        return ihlaller;
    const sirali = [];
    for (const seviye of exports.RISK_SEVIYELERI) {
        const bulunan = bantlar.find((b) => b.seviye === seviye);
        if (bulunan)
            sirali.push(bulunan);
    }
    for (let i = 0; i < sirali.length; i += 1) {
        const bant = sirali[i];
        const sonuncu = i === sirali.length - 1;
        if (sonuncu) {
            if (bant.ustSinir !== null) {
                ihlaller.push('En üst bandın üst sınırı boş bırakılır (∞) — üstünde kademe yoktur');
            }
        }
        else {
            if (bant.ustSinir === null) {
                ihlaller.push(`'${bant.seviye}' bandının üst sınırı zorunludur`);
            }
            else if (bant.ustSinir < bant.altSinir) {
                ihlaller.push(`'${bant.seviye}' bandında üst sınır alt sınırdan küçük`);
            }
            const sonraki = sirali[i + 1];
            if (bant.ustSinir !== null && sonraki.altSinir <= bant.ustSinir) {
                ihlaller.push(`'${bant.seviye}' ile '${sonraki.seviye}' bantları çakışıyor — aralıklar ayrık olmalıdır`);
            }
        }
    }
    return ihlaller;
}
// ── Yenileme periyodu — MEVZUAT SABİTİ (R5) ─────────────────────────────────
/**
 * Risk değerlendirmesinin yenileme aralığı: çok tehlikeli **2 yıl** ·
 * tehlikeli **4 yıl** · az tehlikeli **6 yıl** (Kapsam §16.12/8; ürün sahibi
 * teyit etti). Birim AY (`gecerlilik_ay` tek biçimi — §19/11-1).
 *
 * **TAVANDIR:** müşteri sıkılaştırabilir, GEVŞETEMEZ — muayene tavanının ve
 * ders saati asgarilerinin kardeşi.
 */
exports.RISK_YENILEME_TAVANI_AY = {
    az: 72,
    tehlikeli: 48,
    cok: 24,
};
/** Tarih aritmetiği UTC gün ekseninde (`deriveKanaatBitis` ile AYNI eksen). */
function ayEkle(tarih, ay) {
    const gun = new Date(Date.UTC(tarih.getUTCFullYear(), tarih.getUTCMonth(), tarih.getUTCDate(), 0, 0, 0, 0));
    const hedefGun = gun.getUTCDate();
    gun.setUTCMonth(gun.getUTCMonth() + ay);
    if (gun.getUTCDate() !== hedefGun)
        gun.setUTCDate(0);
    return gun;
}
/**
 * YENİLEME VADESİ TÜRETİLİR (`deriveSonrakiKontrol` ailesinin risk üyesi):
 * **son dondurulmuş sürümün tarihi** + periyot[tehlike sınıfı].
 *
 * Hiç sürüm dondurulmamışsa `null` — henüz imzalanmamış çalışmanın vadesi
 * yoktur (kolon nullable). Tehlike sınıfı yoksa da `null`: sistem, periyodunu
 * bilmediği değerlendirmeye "güncel" diyemez.
 */
function deriveRiskYenilemeVadesi(girdi) {
    if (!girdi.sonDondurma || !girdi.tehlikeSinifi)
        return null;
    const anahtar = (0, egitim_1.tehlikeSinifiAnahtari)(girdi.tehlikeSinifi);
    const tavan = exports.RISK_YENILEME_TAVANI_AY[anahtar];
    const istenen = girdi.periyotAy?.[anahtar];
    const ay = istenen !== undefined && istenen > 0 && istenen <= tavan ? istenen : tavan;
    return ayEkle(girdi.sonDondurma, ay);
}
/** Yenileme periyodu guard'ı (422) — tavanı aşan değer kabul edilmez. */
function riskYenilemePeriyotIhlalleri(periyot) {
    const ihlaller = [];
    for (const anahtar of ['az', 'tehlikeli', 'cok']) {
        const deger = periyot[anahtar];
        if (!Number.isInteger(deger) || deger < 1) {
            ihlaller.push(`Yenileme periyodu en az 1 ay olmalıdır (${anahtar})`);
            continue;
        }
        const tavan = exports.RISK_YENILEME_TAVANI_AY[anahtar];
        if (deger > tavan) {
            ihlaller.push(`Yenileme periyodu mevzuat tavanını aşıyor (${anahtar}: ${deger} ay > ${tavan} ay) — ` +
                'müşteri SIKILAŞTIRABİLİR, gevşetemez');
        }
    }
    return ihlaller;
}
// ── Kural ekseni: mekanizma işareti (§19/11-12) ─────────────────────────────
function kuralNesnesi(kurallar) {
    return typeof kurallar === 'object' && kurallar !== null && !Array.isArray(kurallar)
        ? kurallar
        : null;
}
/**
 * `risk_riski` kaleminin KAZA MEKANİZMASI işareti. Değer hedef mekanizma
 * kaleminin **KÜTÜPHANE REF'idir**, tenant nüsha id'si DEĞİL
 * (`kok_sebep.grup_ref` / `engellenen_izin_turu_refleri` deseni — nüsha
 * dağıtımı düz kopyadır ve hedef tenant'ın id uzayını bilemez).
 *
 * **ANAHTAR TEKİLDİR:** bir risk kalemi tek mekanizmaya bakar; bir
 * mekanizmaya birden çok risk kalemi bağlanır, tersi değil.
 *
 * **İŞARET BİR KAPI DEĞİL, BİR SORGU EKSENİDİR** — boş bırakılan kalem
 * hiçbir kaydı engellemez, yalnız olay↔risk sorgusunda görünmez.
 * `risk_tehlike` tarafında bu eksen YOKTUR (mekanizma = riskin gerçekleşmiş
 * hâli; tehlike = kaynak).
 */
function readMekanizmaRef(kurallar) {
    const deger = kuralNesnesi(kurallar)?.['mekanizma_ref'];
    return typeof deger === 'string' && deger.length > 0 ? deger : null;
}
// ── Tenant yetki listesi (U6 ilkesinin DÖRDÜNCÜ uygulaması — R7) ────────────
/** `risk_degerlendirme` — değerlendirme/madde/ekip/dondurma yetkisini taşıyan
 *  **TEK anahtar** (Kapsam §16.12/10 + §20.5). Yerleşim `tenant_setting`. */
exports.RISK_YETKI_ANAHTARI = 'risk_degerlendirme';
/**
 * VARSAYILAN (R7): **olay U7 deseniyle AYNI** — uzman + teknisyen + şirket
 * yön. + lokasyon yön. **Hekim listede YOKTUR:** ekibe ÜYE olur (R6) ama
 * kayıt yetkisi için tenant listesine AYRICA eklenmelidir — *ekip üyeliği
 * yetki vermez.*
 *
 * **Boş/bozuk liste = varsayılan geçerli** (c1).
 */
exports.RISK_YETKI_VARSAYILAN = [
    'isg_specialist',
    'isg_technician',
    'company_admin',
    'location_manager',
];
/** TABAN KİLİTLER — hiçbir tenant yapılandırması aşamaz. */
function riskYetkiListesiIhlali(liste) {
    for (const sapka of liste) {
        if (!shared_types_1.ROLE_TYPES.includes(sapka)) {
            return `Tanınmayan şapka: ${sapka}`;
        }
        if (sapka === 'viewer') {
            return 'İzleyici hiçbir yazma listesine eklenemez (salt-okunur genel kural)';
        }
        if (sapka === 'contractor_rep') {
            return ('Yüklenici temsilcisi risk değerlendirme listesine eklenemez — değerlendirme ' +
                'İÇ kullanıcı çalışmasıdır ve portal yüzeyi onu görmez (§18.2)');
        }
    }
    return null;
}
function riskDegisiklikOzeti(snapshot, canli) {
    const eski = new Map(snapshot.map((m) => [m.id, m.parmakIzi]));
    let eklenen = 0;
    let degisen = 0;
    for (const madde of canli) {
        const oncekisi = eski.get(madde.id);
        if (oncekisi === undefined)
            eklenen += 1;
        else if (oncekisi !== madde.parmakIzi)
            degisen += 1;
        eski.delete(madde.id);
    }
    const silinen = eski.size;
    return { eklenen, degisen, silinen, degistiMi: eklenen + degisen + silinen > 0 };
}
// ── API sözleşmeleri ────────────────────────────────────────────────────────
const kunyeGovdesi = {
    workplaceId: zod_1.z.uuid(),
    ad: zod_1.z.string().min(1).max(200),
    kapsamTipi: exports.riskKapsamTipiSchema,
    /** `lokasyon` kapsamında ZORUNLU, `faaliyet` kapsamında BOŞ (XOR). */
    locationNodeId: zod_1.z.uuid().nullish(),
    /** `faaliyet` kapsamında ZORUNLU — SERBEST METİN (R2). */
    faaliyetAdi: zod_1.z.string().max(200).nullish(),
};
/** Kapsam XOR'unun şema kolu — DB CHECK'in ve servis guard'ının ikizi. */
function kapsamXorKontrolu(veri, ctx) {
    if (veri.kapsamTipi === 'lokasyon') {
        if (!veri.locationNodeId) {
            ctx.addIssue({ code: 'custom', message: 'Lokasyon kapsamında lokasyon seçilmelidir' });
        }
        if (veri.faaliyetAdi?.trim()) {
            ctx.addIssue({
                code: 'custom',
                message: 'Lokasyon kapsamında faaliyet adı yazılmaz — kapsamı Faaliyet yapın ' +
                    'ya da faaliyet adını boşaltın',
            });
        }
        return;
    }
    if (!veri.faaliyetAdi?.trim()) {
        ctx.addIssue({ code: 'custom', message: 'Faaliyet kapsamında faaliyet adı zorunludur' });
    }
    if (veri.locationNodeId) {
        ctx.addIssue({
            code: 'custom',
            message: 'Faaliyet kapsamında lokasyon seçilmez — kapsamı Lokasyon yapın ya da ' +
                'lokasyon seçimini kaldırın',
        });
    }
}
/**
 * ✏️ **R1 (05.09.2026): GÖVDE ARTIK `metodoloji` TAŞIYABİLİR.** Alan
 * **İSTEĞE BAĞLIDIR** ve boş bırakılırsa sunucu tenant ayarını (varsayılan)
 * yazar — *"çoğu müşteri tek yöntem kullanır"* varsayımı böyle korunur;
 * yöntem seçmek isteyen kullanıcı ise artık holding ayarını değiştirmek
 * zorunda değildir.
 *
 * ⚠️ **DONDURMA DEĞİŞMEDİ:** değer kayda yazılır ve künye düzeltme ucu ona
 * DOKUNMAZ (`riskAssessmentUpdateSchema` — yanlış seçilmişse kayıt silinir,
 * yenisi açılır).
 */
exports.riskAssessmentCreateSchema = zod_1.z
    .object({ ...kunyeGovdesi, metodoloji: exports.riskMetodolojisiSchema.optional() })
    .superRefine((veri, ctx) => kapsamXorKontrolu(veri, ctx));
/** Künye düzeltme — **işyeri ve metodoloji DEĞİŞMEZ.** İşyeri bahçe
 *  eksenidir, metodoloji kaydın ÖLÇEĞİDİR (dondurulmuş; değişirse eski
 *  puanlar sessizce yeni ölçekte okunurdu). Yanlış seçilmişse kayıt silinir,
 *  yenisi açılır (eğitim kaydının tür/işyeri kilidiyle aynı sınıf). */
exports.riskAssessmentUpdateSchema = zod_1.z
    .object({
    ad: kunyeGovdesi.ad,
    kapsamTipi: kunyeGovdesi.kapsamTipi,
    locationNodeId: kunyeGovdesi.locationNodeId,
    faaliyetAdi: kunyeGovdesi.faaliyetAdi,
    durum: exports.riskAssessmentDurumSchema.optional(),
})
    .superRefine((veri, ctx) => kapsamXorKontrolu(veri, ctx));
exports.riskItemWriteSchema = zod_1.z.object({
    sira: zod_1.z.number().int().min(0).max(9999).optional(),
    faaliyet: zod_1.z.string().min(1).max(500),
    tehlikeRefId: zod_1.z.uuid(),
    tehlikeDigerMetin: zod_1.z.string().max(300).nullish(),
    /**
     * ✏️ **YÜZEY DÜRÜSTLÜĞÜ TURU (Kapsam §16.12/16-j): BOŞ KALABİLİR.** Madde
     * tamamlanmadan kaydedilir — kimliği faaliyet + tehlikedir. Boş risk
     * *"risk seçilmedi"* damgası olarak türetilir ve dondurmada kapıdır.
     */
    riskRefId: zod_1.z.uuid().nullish(),
    riskDigerMetin: zod_1.z.string().max(300).nullish(),
    /** ✏️ madde 220 / R7 — rutin / rutin değil; boş = girilmemiş. */
    rutin: zod_1.z.boolean().nullish(),
    mevcutOnlem: zod_1.z.string().max(2000).nullish(),
    /** Yüzey adı "planlanan önlem" (madde 220 / R7). */
    ilaveOnlem: zod_1.z.string().max(2000).nullish(),
    ilgiliMevzuat: zod_1.z.string().max(2000).nullish(),
    /** MEVCUT skor girdileri. */
    olasilik: zod_1.z.number().nullish(),
    frekans: zod_1.z.number().nullish(),
    siddet: zod_1.z.number().nullish(),
    /** HEDEF skor girdileri (madde 220 / R1-R4) — zorunlu değil, eksenler serbest. */
    hedefOlasilik: zod_1.z.number().nullish(),
    hedefFrekans: zod_1.z.number().nullish(),
    hedefSiddet: zod_1.z.number().nullish(),
    locationNodeId: zod_1.z.uuid().nullish(),
    equipmentId: zod_1.z.uuid().nullish(),
});
/**
 * ⚠️ **SORUMLU + TERMİN GİRDİSİ REDDEDİLİR (422) — sessizce yutulmaz**
 * (madde 220 / R7; tur 6'nın `saha_giris_onay` deseni). İki alan bugüne kadar
 * gövdede kabul ediliyordu; şema onları sessizce düşürseydi eski bir
 * istemcinin gönderdiği termin *"kaydedildi"* görünür ve hiçbir yerde
 * yaşamazdı (§2.40). Mesaj ne yapılacağını söyler (D2).
 */
exports.RISK_TAKIP_GIRDISI_ALANLARI = ['sorumluPersonId', 'termin'];
exports.RISK_TAKIP_GIRDISI_MESAJI = 'Sorumlu ve termin maddeye yazılmaz — maddeden aksiyon açın; satırda aksiyonun ' +
    'sorumlusu ve termini görünür';
function riskTakipGirdisiVarMi(govde) {
    if (typeof govde !== 'object' || govde === null)
        return false;
    return exports.RISK_TAKIP_GIRDISI_ALANLARI.some((alan) => alan in govde);
}
/** Rutin sütununun metni — ekran ve PDF AYNI kelimeyi basar. */
function riskRutinEtiketi(rutin) {
    if (rutin === null)
        return '—';
    return rutin ? 'Rutin' : 'Rutin değil';
}
/**
 * ✏️ **KISMİ MADDE — TAMAMLANMAMIŞ DAMGASI (yüzey dürüstlüğü turu; Kapsam
 * §16.12/16-j).** Madde tamamlanmadan kaydedilir (en az faaliyet + tehlike);
 * eksiklik **KOLON DEĞİL, TÜRETMEDİR** ve TEK yüklemden okunur:
 *
 * - `skor` — mevcut skor hesaplanamıyor (`hamSkor` boş: yöntemin istediği bir
 *   eksen girilmemiş). ⚠️ *"Bantsız"* DEĞİLDİR — bant tablosu boşken skorlu
 *   madde bantsız kalır (D8) ama skorludur.
 * - `risk` — risk (gerçekleşme) kalemi seçilmemiş.
 *
 * Okuyucular: detay satırının damgası · detayın uyarı bandı · sürüm dondurma
 * kapısı (`riskDondurmaEngeli`). SQL ikizi `@isg/db riskMaddeEksikKosulu` —
 * *Tamamlanmamış* süzgeci onu okur; ⚠️ **ikisi AYNI commit'te değişir**
 * (kanaryası `@isg/db risk.spec` → *"ikiz"*).
 */
exports.RISK_MADDE_EKSIKLERI = ['skor', 'risk'];
/** Satır damgasının metni — ekran bunu basar, kendi kelimesini yazmaz. */
exports.RISK_MADDE_EKSIK_ETIKETI = {
    skor: 'skorlanmadı',
    risk: 'risk seçilmedi',
};
const RISK_MADDE_EKSIK_GRUBU = {
    skor: 'skorlanmamış',
    risk: 'riski seçilmemiş',
};
function riskMaddeEksikleri(madde) {
    return exports.RISK_MADDE_EKSIKLERI.filter((eksik) => eksik === 'skor' ? madde.hamSkor === null : madde.risk === null);
}
/** Madde listesi DURUM süzgecinin tanınan değerleri — tanınmayan değer 400. */
exports.RISK_MADDE_DURUM_SUZGECLERI = ['eksik'];
exports.riskMaddeDurumSuzgeciSchema = zod_1.z.enum(exports.RISK_MADDE_DURUM_SUZGECLERI);
/** Engel mesajında grup başına adıyla sayılan en çok madde (kalanı "+n"). */
const DONDURMA_ENGELI_AD_SINIRI = 5;
/**
 * ⚠️ **İMZADA KAPI (R5'in kardeşi — ama anahtara bağlı DEĞİL).** Tamamlanmamış
 * madde varken sürüm dondurulamaz: imzalanan belge eksik olamaz. Mesaj
 * eksikleri **sayar ve adıyla listeler** ve ne yapılacağını söyler (D2).
 * `null` = engel yok.
 *
 * Servisin 422'si ve detayın **önceden** uyarısı AYNI çağrıyı yapar — kullanıcı
 * düğmeye basmadan eksiği görür (§2.40: kapı ile görünürlük tek yüklemden).
 */
function riskDondurmaEngeli(maddeler) {
    const gruplar = exports.RISK_MADDE_EKSIKLERI.map((eksik) => ({
        eksik,
        adlar: maddeler.filter((m) => riskMaddeEksikleri(m).includes(eksik)).map((m) => m.faaliyet),
    })).filter((g) => g.adlar.length > 0);
    if (gruplar.length === 0)
        return null;
    const parca = (g) => {
        const gorunen = g.adlar
            .slice(0, DONDURMA_ENGELI_AD_SINIRI)
            .map((ad) => `«${ad}»`)
            .join(', ');
        const kalan = g.adlar.length - DONDURMA_ENGELI_AD_SINIRI;
        return `${RISK_MADDE_EKSIK_GRUBU[g.eksik]} ${g.adlar.length} madde: ${gorunen}${kalan > 0 ? ` +${kalan}` : ''}`;
    };
    return (`Sürüm dondurulamaz — tamamlanmamış madde var (${gruplar.map(parca).join(' · ')}). ` +
        'Eksikleri tamamlayın ya da maddeyi silin');
}
exports.riskAssessmentMemberWriteSchema = zod_1.z.object({
    personId: zod_1.z.uuid(),
    gorevMetni: zod_1.z.string().max(200).nullish(),
});
exports.riskFreezeSchema = zod_1.z.object({
    not: zod_1.z.string().max(1000).nullish(),
});
exports.riskBandWriteSchema = zod_1.z.object({
    metodoloji: exports.riskMetodolojisiSchema,
    bantlar: zod_1.z
        .array(zod_1.z.object({
        seviye: exports.riskSeviyesiSchema,
        altSinir: zod_1.z.number(),
        ustSinir: zod_1.z.number().nullish(),
    }))
        .min(1)
        .max(exports.RISK_SEVIYELERI.length),
});
exports.riskItemSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    sira: zod_1.z.number().int(),
    faaliyet: zod_1.z.string(),
    /** Satır içi düzenleme (P1) ref'i geri yazar — ad tek başına yetmez. */
    tehlikeRefId: zod_1.z.uuid(),
    tehlike: zod_1.z.string(),
    tehlikeDigerMetin: zod_1.z.string().nullable(),
    /** ✏️ Kısmi madde (§16.12/16-j): risk seçilmemiş olabilir. */
    riskRefId: zod_1.z.uuid().nullable(),
    risk: zod_1.z.string().nullable(),
    riskDigerMetin: zod_1.z.string().nullable(),
    /**
     * TÜRETİLMİŞ — `riskMaddeEksikleri` (kolon DEĞİL). Boş dizi = tamamlanmış;
     * satır damgası (*skorlanmadı* · *risk seçilmedi*) buradan çizilir.
     */
    eksikler: zod_1.z.array(zod_1.z.enum(exports.RISK_MADDE_EKSIKLERI)),
    rutin: zod_1.z.boolean().nullable(),
    mevcutOnlem: zod_1.z.string().nullable(),
    ilaveOnlem: zod_1.z.string().nullable(),
    ilgiliMevzuat: zod_1.z.string().nullable(),
    /** MEVCUT skor — girdiler + TÜRETİLEN üçlü (kolonda saklı, tek yazıcı). */
    olasilik: zod_1.z.number().nullable(),
    frekans: zod_1.z.number().nullable(),
    siddet: zod_1.z.number().nullable(),
    hamSkor: zod_1.z.number().nullable(),
    riskSeviyesi: exports.riskSeviyesiSchema.nullable(),
    kabulEdilebilir: zod_1.z.boolean().nullable(),
    /**
     * HEDEF skor (madde 220 / R1) — girdiler kolonda, **değer ve bant
     * TÜRETİLİR** (okumada güncel bant tablosuyla; kolon YOK). ⚠️ Hiçbir kapı
     * bu iki alanı okumaz (R2).
     */
    hedefOlasilik: zod_1.z.number().nullable(),
    hedefFrekans: zod_1.z.number().nullable(),
    hedefSiddet: zod_1.z.number().nullable(),
    hedefHamSkor: zod_1.z.number().nullable(),
    hedefRiskSeviyesi: exports.riskSeviyesiSchema.nullable(),
    locationNodeId: zod_1.z.uuid().nullable(),
    locationAd: zod_1.z.string().nullable(),
    equipmentId: zod_1.z.uuid().nullable(),
    equipmentAd: zod_1.z.string().nullable(),
    /**
     * ⚠️ SORUMLU + TERMİN KOLON DEĞİL — AKSİYONDAN TÜRETİLİR (madde 220 / R7;
     * `riskMaddeTakibi`): canlı aksiyonların en yakın terminlisi, yoksa en son
     * kapanan; aksiyonsuz maddede ikisi de `null`.
     */
    sorumluAd: zod_1.z.string().nullable(),
    termin: zod_1.z.iso.date().nullable(),
    /** TÜRETİLMİŞ — İPTAL HARİÇ `action.risk_item_id` sayımı (R5 uyarısının girdisi). */
    aksiyonSayisi: zod_1.z.number().int(),
    acikAksiyonSayisi: zod_1.z.number().int(),
    /**
     * Y2 — DÖF ÖNERİ ÇAĞRISI (Kapsam §16.12/8b). TÜRETİLMİŞ İŞARET, kolon
     * DEĞİL: puan `risk_dof_oneri_esigi`ni geçiyor mu. **Z2 gereği HER ZAMAN
     * GÜNCEL eşikle** hesaplanır; **Z6 gereği `risk_aksiyon_zorunlu`dan
     * BAĞIMSIZDIR** — anahtar kapalıyken de çıkar (öneri bir ÇAĞRI, anahtar
     * bir KAPI).
     */
    dofOnerilir: zod_1.z.boolean(),
});
exports.riskAssessmentSummarySchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    ad: zod_1.z.string(),
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string(),
    kapsamTipi: exports.riskKapsamTipiSchema,
    locationAd: zod_1.z.string().nullable(),
    faaliyetAdi: zod_1.z.string().nullable(),
    metodoloji: exports.riskMetodolojisiSchema,
    durum: exports.riskAssessmentDurumSchema,
    maddeSayisi: zod_1.z.number().int(),
    sonSurumNo: zod_1.z.number().int().nullable(),
    sonDondurma: zod_1.z.string().nullable(),
    sonrakiYenileme: zod_1.z.iso.date().nullable(),
    /** TÜRETİLMİŞ işaretler — kolon DEĞİL. */
    vadesiDoldu: zod_1.z.boolean(),
    imzadanBeriDegisti: zod_1.z.boolean(),
    yuksekBantAksiyonsuz: zod_1.z.number().int(),
});
/**
 * AYRIK ÖLÇEK KADEMELERİ (FARK 5) — ekran açılır listeyi BUNDAN çizer;
 * `riskPuanIhlalleri` aynı kümeyi doğrular (çift kilit, tek kaynak
 * `riskOlcekleri`).
 */
exports.riskOlceklerSchema = zod_1.z.object({
    olasilik: zod_1.z.array(zod_1.z.object({ deger: zod_1.z.number(), etiket: zod_1.z.string() })),
    frekans: zod_1.z.array(zod_1.z.object({ deger: zod_1.z.number(), etiket: zod_1.z.string() })).nullable(),
    siddet: zod_1.z.array(zod_1.z.object({ deger: zod_1.z.number(), etiket: zod_1.z.string() })),
});
/** P4 — sayfalama + görünür süzgeç + toplam (aksiyon/izin listesiyle aynı kalıp). */
exports.riskAssessmentListSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.riskAssessmentSummarySchema),
    toplam: zod_1.z.number().int(),
    sayfa: zod_1.z.number().int(),
    sayfaBoyutu: zod_1.z.number().int(),
});
exports.riskAssessmentDetailSchema = exports.riskAssessmentSummarySchema.extend({
    locationNodeId: zod_1.z.uuid().nullable(),
    /**
     * ⚠️ **R7 — MADDE LİSTESİ SUNUCUDA SAYFALANIR VE SÜZÜLÜR.** Seed'de dört
     * madde vardır; gerçek bir işyeri risk değerlendirmesi **100-500** madde
     * taşır ve o ölçekte tek tablo §2.40'ın **c-2** koluna düşer (görünüyor ·
     * çalışıyor · KULLANILAMIYOR). Satır içi düzenleme KORUNUR — sayfa başına.
     */
    maddeler: zod_1.z.array(exports.riskItemSummarySchema),
    /** Süzgeçten geçen madde sayısı (`maddeSayisi` süzgeçSİZ toplamdır). */
    maddeToplam: zod_1.z.number().int(),
    maddeSayfa: zod_1.z.number().int(),
    maddeSayfaBoyutu: zod_1.z.number().int(),
    /**
     * ⚠️ **ÖLÇEK KAYDIN KENDİ METODOLOJİSİNDEN GELİR, TENANT AYARINDAN
     * DEĞİL** (R1'in zorunlu tamamlayıcısı). Bu alan `options` ucundaydı ve
     * orası tenant ayarını okuyordu: yöntem değerlendirme başına
     * seçilebildiği an, 5x5 varsayılanlı bir holdingde açılan Fine-Kinney
     * kaydı ekranda **1-5 kademeleri** görür, sunucu ise onları **reddederdi**
     * (§2.40 — kural doğru, sunum yanlış). Tek kaynak: kaydın `metodoloji`si.
     */
    olcekler: exports.riskOlceklerSchema,
    ekip: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        personId: zod_1.z.uuid(),
        adSoyad: zod_1.z.string(),
        gorevMetni: zod_1.z.string().nullable(),
    })),
    surumler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        surumNo: zod_1.z.number().int(),
        dondurulduAt: zod_1.z.string(),
        maddeSayisi: zod_1.z.number().int(),
        not: zod_1.z.string().nullable(),
    })),
    degisiklik: zod_1.z.object({
        eklenen: zod_1.z.number().int(),
        degisen: zod_1.z.number().int(),
        silinen: zod_1.z.number().int(),
        degistiMi: zod_1.z.boolean(),
    }),
    /** D8 deseni: bant tablosu yoksa seviye NULL kalır ve BU uyarı çıkar. */
    uyarilar: zod_1.z.array(zod_1.z.string()),
    yetkiler: zod_1.z.object({
        duzenleyebilir: zod_1.z.boolean(),
        dondurabilir: zod_1.z.boolean(),
        /** R5: anahtar açıkken yüksek bantta aksiyonsuz madde dondurmayı ENGELLER. */
        aksiyonZorunlu: zod_1.z.boolean(),
        /**
         * P13 · B1/6 — risk yazma kapısı (tenant `risk_degerlendirme` listesi →
         * bahçe → değerlendirme aktif) + sebep. Maddeler · künye · ekip · sürüm
         * dondurma bu kapıdan çizilir; liste tenant ayarı olduğu için sebebin şapka
         * listesi SUNUCUDAN gelir.
         */
        yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
        /**
         * P13 — maddeden *"Aksiyon aç"* = AKSİYON AÇMA kapısı (aksiyon şapkaları →
         * bahçe → arşiv → `uzman_aksiyon_atama`). Eski düğme risk yazma bayrağına
         * bakıyordu: risk listesi üyesi olup aksiyon şapkası olmayan 403 alıyordu.
         */
        aksiyonKapisi: kapi_durumu_1.kapiDurumuSchema,
    }),
});
/** İki hedef sorgunun ORTAK yanıt biçimi (§16.12/12) — tek şema, iki uç. */
exports.riskEslesmeSchema = zod_1.z.object({
    bulundu: zod_1.z.boolean(),
    maddeler: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        assessmentId: zod_1.z.uuid(),
        assessmentAd: zod_1.z.string(),
        faaliyet: zod_1.z.string(),
        tehlike: zod_1.z.string(),
        /** Kısmi madde (§16.12/16-j): lokasyon/ekipman ekseninden gelen madde riski seçilmemiş olabilir. */
        risk: zod_1.z.string().nullable(),
        mevcutOnlem: zod_1.z.string().nullable(),
        ilaveOnlem: zod_1.z.string().nullable(),
        riskSeviyesi: exports.riskSeviyesiSchema.nullable(),
        /** Eşleşme hangi eksenden geldi — ekran bunu rozet olarak gösterir. */
        eslesmeEkseni: zod_1.z.array(zod_1.z.enum(['lokasyon', 'mekanizma', 'ekipman'])),
    })),
    /** Bulunamadığında ekranın basacağı cümle — sunucudan gelir (tek dil). */
    mesaj: zod_1.z.string(),
});
exports.riskAssessmentOptionsSchema = zod_1.z.object({
    workplaces: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.uuid(),
        ad: zod_1.z.string(),
        companyAd: zod_1.z.string(),
        locations: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    })),
    tehlikeler: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    riskler: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string() })),
    equipments: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string(), workplaceId: zod_1.z.uuid() })),
    personeller: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), adSoyad: zod_1.z.string() })),
    /**
     * Tenant'ın VARSAYILAN yöntemi — açılış modalı bununla gelir (R1). Kaydın
     * kendi yöntemi buradan bağımsızdır ve detay ucundan okunur.
     *
     * ⚠️ **`olcekler` BU UÇTAN DÜŞTÜ (R1):** kademeleri tenant ayarından
     * çizmek, başka yöntemle açılmış bir kaydın ekranını yanlış kurardı —
     * ölçek artık `riskAssessmentDetailSchema.olcekler`dedir.
     */
    metodoloji: exports.riskMetodolojisiSchema,
    kayitAcabilir: zod_1.z.boolean(),
});
exports.riskBandListSchema = zod_1.z.object({
    metodoloji: exports.riskMetodolojisiSchema,
    bantlar: zod_1.z.array(zod_1.z.object({
        seviye: exports.riskSeviyesiSchema,
        altSinir: zod_1.z.number(),
        ustSinir: zod_1.z.number().nullable(),
    })),
    /** Kütüphane varsayılanı mı, müşteri düzenlemesi mi (ekran şerhi). */
    tanimliMi: zod_1.z.boolean(),
});
// ── Toplu yükleme raporu (F4·S9 — içe aktarma motoru) ───────────────────────
/**
 * RİSK MADDELERİ TOPLU YÜKLEME RAPORU (`workHoursImportReportSchema`
 * deseni). **KISMİ BAŞARI SATIR DÜZEYİNDE:** bozuk satır isteği düşürmez,
 * geçerli satırlar eklenir; **YETKİ VE KAYIT DURUMU İSTEK DÜZEYİNDEDİR**
 * (yetkisiz 403 · arşivlenmiş değerlendirme 409 → hiçbir satır işlenmez).
 */
exports.RISK_ITEM_IMPORT_SONUCLARI = ['eklendi', 'hata'];
exports.riskItemImportSonucSchema = zod_1.z.enum(exports.RISK_ITEM_IMPORT_SONUCLARI);
exports.riskItemImportRowResultSchema = zod_1.z.object({
    satir: zod_1.z.number().int().positive(),
    sonuc: exports.riskItemImportSonucSchema,
    mesaj: zod_1.z.string().nullable(),
});
exports.riskItemImportReportSchema = zod_1.z.object({
    toplam: zod_1.z.number().int().min(0),
    eklenen: zod_1.z.number().int().min(0),
    hatali: zod_1.z.number().int().min(0),
    satirlar: zod_1.z.array(exports.riskItemImportRowResultSchema),
});
// ── Türkçe etiketler (TEK KAYNAK) ──────────────────────────────────────────
/**
 * Kilitli enum'ların Türkçe etiketleri. `TENANT_ANAHTAR_ETIKETLERI`
 * emsalindedir: metin **üç katmanın da ihtiyacı** olduğu için burada durur —
 * ekran rozeti bunu okur, **PDF çıktısı da** (çıktı SUNUCUDA üretilir,
 * F4·S9). İki ayrı harita tutulsaydı ekran "Tolere edilemez" derken belge
 * "unacceptable" diyebilirdi; denetime giden kağıtta bu kabul edilemez.
 *
 * ⚠️ Şemaya metin GÖMÜLMEZ (adlandırma konvansiyonu): enum değerleri
 * İngilizce token olarak kalır, çevrilen yalnız etikettir.
 */
exports.RISK_SEVIYESI_ETIKETI = {
    low: 'Kabul edilebilir',
    medium: 'Dikkat',
    high: 'Yüksek',
    unacceptable: 'Tolere edilemez',
};
exports.RISK_METODOLOJI_ETIKETI = {
    matrix_5x5: '5x5 matris',
    fine_kinney: 'Fine-Kinney',
};
exports.RISK_KAPSAM_ETIKETI = {
    lokasyon: 'Lokasyon',
    faaliyet: 'Faaliyet',
};
//# sourceMappingURL=risk.js.map